import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../atoms/modal/Modal';

const ModalOtherPage = ({
  open, onClose, srcUrl,
}) => {

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="otherPageModal"
      bodyClassName="otherPageModalBody"
      overlayClassName="cautionModalOverlay"
      shouldCloseOnOverlayClick={true}
      customHeader={() => (
        <div className="otherPageModalHeader">
          <div className="cautionModalClose" onClick={onClose}/>
        </div>
      )}
      disableBodyScroll={false}
    >
      <iframe className="otherPageModalContent hideScrollbar" src={srcUrl} />
    </Modal>
  );
};

ModalOtherPage.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  srcUrl: PropTypes.string.isRequired,
};

export default ModalOtherPage;
